import { render } from "./Scrollbar.vue?vue&type=template&id=78ec2ddc"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"

import "./Scrollbar.vue?vue&type=style&index=0&id=78ec2ddc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__